/* eslint-disable react/no-multi-comp */
import React from "react";

import { List, Typography, makeStyles } from "@material-ui/core";
import { matchPath, useLocation } from "react-router-dom";
import clsx from "clsx";

import { NavigationListItem } from "./components";
import { PageChild } from "layouts/Dashboard/components/NavBar/navigationConfig";

import { useTealium } from "@hubcapp/context";

const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: theme.spacing(3),
  },
}));

interface NavigationListProps {
  depth: number;
  pages: PageChild[];
  location: any;
}

interface ReduceChildRoutesProps {
  location: any;
  items: JSX.Element[];
  page: PageChild;
  depth: number;
}

interface NavigationProps {
  title: string;
  pages: PageChild[];
  className?: string;
  component: any;
}

const NavigationList = (props: NavigationListProps) => {
  const { pages, ...rest } = props;

  return (
    <List>
      {pages.reduce<JSX.Element[]>(
        (items, page) => reduceChildRoutes({ items, page, ...rest }),
        [],
      )}
    </List>
  );
};

const reduceChildRoutes = (props: ReduceChildRoutesProps) => {
  const { location, items, page, depth } = props;
  const { trackEvent } = useTealium();

  if (page.children) {
    const open = matchPath(location.pathname, {
      path: page.href,
      exact: false,
    });

    items.push(
      <NavigationListItem
        depth={depth}
        icon={page.icon}
        key={page.title}
        label={page.label}
        open={Boolean(open)}
        title={page.title}
        onClick={() => {
          trackEvent({
            eventCategory: "Menu",
            eventAction: "Interaction",
            eventLabel: page.title,
          });
        }}
      >
        <NavigationList
          depth={depth + 1}
          pages={page.children}
          location={location}
        />
      </NavigationListItem>,
    );
  } else {
    items.push(
      <NavigationListItem
        depth={depth}
        href={page.href}
        icon={page.icon}
        key={page.title}
        label={page.label}
        title={page.title}
        onClick={() => {
          trackEvent({
            eventCategory: "Menu",
            eventAction: "Interaction",
            eventLabel: page.title,
          });
        }}
      />,
    );
  }

  return items;
};

const Navigation = (props: NavigationProps) => {
  const { title, pages, className, component: Component, ...rest } = props;

  const classes = useStyles();
  const location = useLocation();

  return (
    <Component {...rest} className={clsx(classes.root, className)}>
      {title && <Typography variant="overline">{title}</Typography>}
      <NavigationList depth={0} pages={pages} location={location} />
    </Component>
  );
};

Navigation.defaultProps = {
  component: "nav",
};

export default Navigation;
